import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { installTossRecovery } from './platform/native-recovery';
import { platform } from './platform/adapter';
import { installNativeLifecycle } from './platform/native-lifecycle';
import './design/tokens.css';
import './design/app.css';

document.documentElement.dataset.channel = platform.channel;
if (platform.lightOnly) document.documentElement.dataset.theme = 'light';

installTossRecovery();

createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);

void installNativeLifecycle((path) => {
  history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
});

if (!platform.native && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}
